import { Stack } from '@mui/material'
import { FC, useState } from 'react'
import { useSnapshot } from 'valtio'
import { CurrentTestState } from '@app/storage'
import { VideoModal, VideoThumbnail } from './components'

interface Props {
  thumbnailHtml?: string
  iframeHtml?: string
}

// Extract wistiaId from either to use in transcript fetch
const extractWistiaId = (url?: string): string | null => {
  if (!url) return null
  const match = url.match(/wistia\.(?:com|net)\/embed\/(?:iframe|medias)\/([a-z0-9]+)/i)
  return match?.[1] ?? null
}

const VideoFeedback: FC<Props> = ({ thumbnailHtml, iframeHtml }) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false)
  const { currentItemResponse, itemsResponses } = useSnapshot(CurrentTestState)
  const questionNumber = itemsResponses.findIndex(item => item.id === currentItemResponse?.id) + 1

  if (!thumbnailHtml && !iframeHtml) return null

  const wistiaId = extractWistiaId(iframeHtml)

  return (
    <Stack alignItems='center'>
      <VideoThumbnail
        thumbnailHtml={thumbnailHtml}
        questionNumber={questionNumber}
        onClick={() => setIsVideoModalOpen(true)}
      />

      <VideoModal
        iframeHtml={iframeHtml}
        open={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        wistiaId={wistiaId}
        questionNumber={questionNumber}
      />
    </Stack>
  )
}

export default VideoFeedback
